/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=073a55ec&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=073a55ec&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/vue-ddm-quiz-pc-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__